export enum Roles {
  RANGER = 'ranger',
  WSL_WALD = 'wld'
}
